<template>
    <div :class="`phone-number phone-number-align-${align}`">
        <label for="phone-number">{{ fieldPhone }}</label>
        <div :class="['input-wrapper', { 'error': showError && isRequired && !phoneNumberValue }]">
            <input type="tel" id="phone-number" name="phone-number" v-model="phoneNumberValue" @input="emitValues" />
            <label for="phone-number">{{ masked }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormPhoneNumber",
    props: {
        fieldPhone: {
            type: String,
            required: true,
        },
        align: {
            type: String,
            required: true,
        },
        masked: {
            type: String,
            required: true,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        showError: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default: () => ({ phoneNumber: "" }),
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            phoneNumberValue: this.value.phoneNumber,
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.phoneNumberValue = newValue.phoneNumber;
            },
            deep: true,
        },
        showError: {
            handler(newShowError) {
                if (newShowError) {
                    this.phoneNumberValue = "";
                }
            },
        },
    },
    methods: {
        emitValues() {
            const phoneData = {
                phoneNumber: this.phoneNumberValue,
                fieldPhone: this.fieldPhone,
                masked: this.masked,
            };
            this.$emit("input", phoneData);
            this.$emit("validate", {
                fieldId: this._uid,
                hasError: this.isRequired && !this.phoneNumberValue,
            });
            localStorage.setItem(`${this.formId}-${this.order}`, JSON.stringify(phoneData));
        },
        loadValues() {
            const savedData = localStorage.getItem(`${this.formId}-${this.order}`);
            if (savedData) {
                const parsedData = JSON.parse(savedData);
                this.phoneNumberValue = parsedData.phoneNumber;
            }
        }
    },
    mounted() {
        this.loadValues();
        this.emitValues();
    }
};
</script>

<style lang="scss" scoped>
.phone-number-align-left {
    display: flex;

    > label {
        font-size: 14px !important;
        width: 150px !important;
    }

    .input-wrapper {
        width: 100%;
    }
}

.phone-number-align-right {
    display: flex;

    > label {
        font-size: 14px !important;
        width: 150px !important;
        text-align: right;
        margin-right: 5px;
    }

    .input-wrapper {
        width: 100%;
    }
}

.phone-number {
    width: 100%;
    max-width: 600px;
    margin: 10px auto;
    text-align: left;

    > label {
        display: block;
        font-size: 18px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #2c3e50;
    }

    .input-wrapper {
        display: flex;
        flex-direction: column;
        position: relative;

        input {
            width: 100%;
            padding: 8px;
            font-size: 14px;
            border: 1px solid #ccd6dd;
            border-radius: 4px;
            box-sizing: border-box;
            margin-bottom: 4px;
        }

        label {
            font-size: 12px;
            color: #8696a0;
            margin-top: 4px;
        }

        &.error input {
            border: 1px solid red;
        }

        .error-message {
            color: red;
            font-size: 10px;
            position: absolute;
            bottom: -18px;
            left: 0;
        }
    }
}
</style>